import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";
import Swal from 'sweetalert2';
import moment from 'moment';

const LISTADO_ND = 'LISTADO_ND';
const NOTA_DEBITO = 'NOTA_DEBITO';
const DETALLE_ND = 'DETALLE_ND';
const LOADER = 'LOADER';
const MODULO = 'MODULO';
const PERIODO_D = 'PERIODO_D';
const PARAMETRO = 'PARAMETRO';
const LOADERC = 'LOADERC';
const DETALLE = 'DETALLE';
const CUENTA_CONTABLE = 'CUENTA_CONTABLE';
const LISTA_GASTOS = 'LISTA_GASTOS';
const NOMBRE_CC = 'NOMBRE_CC';

const setLoader = loader => ({
    type: LOADER,
    loader,
});


export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let id_period = id_emp[7];
    const params = { id, id_period };
    dispatch(setLoader(true));
    api.get('/distribuidor/nota_debito', params).then((response) => {
        dispatch({ type: LISTADO_ND, data: response });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al listar notas de débito',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const leerPeriodoD = (id, id_periodo) => (dispatch) => {
    const params = { id, id_periodo };
    api.get('/periodos/periodo', params).then((response) => {
        dispatch({ type: PERIODO_D, periodoD: response.periodo });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al consultar periodo',
            'Error',
            2000
        );
    })
}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar modulo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const parametrosEmpresa = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id}
    dispatch(setLoader(true));
    api.get('/empresa/empresa_parametros', params).then((response) => {
        dispatch({type: PARAMETRO, datos: response });
    }).catch((error)=>{
        
        NotificationManager.error(
            'Ocurrió un error al consultar parametros',
            'Error',
            8000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const listarDistribuidor = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id, search}
    return api.get('/distribuidor/distribuidor',params).then(data=>{
        const list_distribuidor = [];
        if(data){
            data.forEach(item=>{
                list_distribuidor.push({
                    value: item.id,
                    label: item.nombre
                })
            })
        }
        return list_distribuidor ;
    }).catch((error)=>{
        
        return [];
    })
}

export const listarDistribuidorCC = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id, search}
    return api.get('/visitador_medico/centro_costo',params).then(data=>{
        const list_distribuidor_cc = [];
        if(data){
            data.forEach(item=>{
                list_distribuidor_cc.push({
                    value: item.id,
                    label: item.codigo + ' -- ' + item.descripcion
                })
            })
        }
        return list_distribuidor_cc ;
    }).catch((error)=>{
        
        return [];
    })
}

const eliminarLineaNota = id => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`distribuidor/nota_debito_detalle/${id}`).then((response) => {
        dispatch(leerDetalleND(response.id));
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en eliminar linea de poliza',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const agregarLinea = (periodoD) => (dispatch, getStore) => {
    const data = getStore().form.FormNotaDebitoVM.values;
    
    let fechaI = moment(periodoD.fecha_inicio);
    let fechaF = moment(periodoD.fecha_fin);
    let fecha = moment(data.fecha_registro);

    if (fecha >= fechaI && fecha <= fechaF) {
        if (data.total_linea === 0.00 || data.total_linea === undefined){
            Swal.fire({
                title: 'Nota de débito',
                text: 'Total no puede ser 0.00',
                type: 'error',
            })
        }else{
            if (data.descripcion_linea === '' || data.descripcion_linea === undefined) {
                Swal.fire({
                    title: 'Nota de débito',
                    text: 'Debe de ingresar descripción',
                    type: 'error',
                })
            } else {
                if (data.tipo_gasto === '' || data.tipo_gasto === undefined || data.tipo_gasto === null) {
                    Swal.fire({
                        title: 'Nota de débito',
                        text: 'Debe de seleccionar tipo de gasto',
                        type: 'error',
                    })
                } else {
                    if (data.cuenta === '' || data.cuenta === undefined || data.cuenta === null) {
                        Swal.fire({
                            title: 'Nota de débito',
                            text: 'Debe de seleccionar cuenta contable',
                            type: 'error',
                        })
                    } else {
                        if (data.centro_costo === '' || data.centro_costo === undefined || data.centro_costo === null) {
                            Swal.fire({
                                title: 'Nota de débito',
                                text: 'Debe de seleccionar centro de costo',
                                type: 'error',
                            })
                        } else {
                            const detalleActual = data.detalleD || [];
                            const nuevoDetalle = [
                                ...detalleActual,
                                {
                                    id: Date.now(),
                                    descripcion: data.descripcion_linea,
                                    total:data.total_linea,
                                    gasto_id: data.tipo_gasto.value,
                                    gasto: data.tipo_gasto.label,
                                    cuenta: data.cuenta.value,
                                    nombre_cuenta: data.cuenta.label,
                                    cc: data.centro_costo.value,
                                    nombre_cc: data.centro_costo.label
                                }
                            ];
                            data.descripcion_linea = "";
                            data.detalleD = nuevoDetalle;
                            data.total_linea = 0;
                            NotificationManager.success(
                                'Linea ingresada correctamente',
                                'Exito',
                                3000
                            );
                            dispatch(actualizar());
                        }
                    }
                }
            }
        }
    }else {
        Swal.fire({
            title: 'Nota de débito',
            text: 'Fecha fuera del periodo',
            type: 'error',
        })
    }
}

const actualizar = () => (dispatch, getStore) => {
    const data = getStore().form.FormNotaDebitoVM.values;
    dispatch(initializeForm(
        'FormNotaDebitoVM', {
            ...data,
            tipo_gasto: null,
            cuenta: null,
            centro_costo: null
    }));
    dispatch({ type: DETALLE, detalleDocN: data.detalleD });
};

export const registroNotaDebito = (periodoD) => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormNotaDebitoVM.values;
    let fechaI = moment(periodoD.fecha_inicio);
    let fechaF = moment(periodoD.fecha_fin);
    let fecha = moment(data.fecha_registro);
    if (fecha>=fechaI && fecha<=fechaF){
        if (data.detalleD.length === 0) {
            Swal.fire({
                title: 'Nota de débito',
                text: 'Debe de ingresar detalle de la nota de débito',
                type: 'error',
            })
        }else{
            const formData = {
                fecha_registro: data.fecha_registro,
                descripcion: data.descripcion,
                distribuidor: data.distribuidor.value,
                numero: data.numero,
                detalleNota: data.detalleD,
                empresa: id_emp[5],
                periodo: id_emp[7],
            }
            dispatch(setLoader(true));
            api.post('/distribuidor/nota_debito/', formData).then(() => {
                NotificationManager.success(
                    'Nota de débito creado correctamente',
                    'Exito',
                    3000
                );
                setTimeout(function () {
                    window.location.reload(true);
                }, 2000);
            }).catch((error) => {
                NotificationManager.error(
                    error.msj,
                    'Error',
                    2000
                );
            }).finally(() => {
                dispatch(setLoader(false));
            });
        }
    }else {
        Swal.fire({
            title: 'Nota de débito',
            text: 'Fecha fuera del periodo',
            type: 'error',
        })    
    }
}

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/distribuidor/nota_debito/${id}`).then((response) => {
        dispatch({ type: NOTA_DEBITO, lectura: response });
        dispatch(initializeForm('FormNotaDebitoVM', response ));
        dispatch(leerDetalleND(response.id));
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al consultar nota de débito',
            'Error',
            8000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

const leerDetalleND = (id_nota ) => (dispatch) => {
    api.get(`/distribuidor/nota_debito_detalle/${id_nota}`).then((response)=>{
        dispatch({ type: DETALLE_ND, detalleND: response });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error',
            'Error',
            0
        );
    })
};

const eliminarLinea = (id) => (dispatch, getStore) => {
    const data = getStore().form.FormNotaDebitoVM.values;
    const nuevoDetalle = data.detalleD.filter(element => element.id !== id);
    dispatch({ type: DETALLE, detalleDocN: nuevoDetalle });
    dispatch(initializeForm('FormNotaDebitoVM', {
        ...data,
        detalleD: nuevoDetalle,
        tipo_gasto: null,
        cuenta: null
    }));
};

const limpiar = () => (dispatch) => {
    dispatch(initializeForm('FormNotaDebitoVM'));
    dispatch({ type: DETALLE, detalleDocN: [] });
};


export const listarTiposGasto = (search) => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id, search}
    api.get('/distribuidor/tipo_gasto/',params).then(data=>{
        const list_gastos = [];
        if(data){
            data.forEach(item=>{
                list_gastos.push({
                    value: item.id,
                    label: item.descripcion
                })
            })
        }
        dispatch({type: LISTA_GASTOS, gastos: list_gastos })
    }).catch(()=>{
        return [];
    })
}

export const agregarNuevaLinea = (periodoD) => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    
    const data = getStore().form.FormNotaDebitoVM.values;

    let fechaI = moment(periodoD.fecha_inicio);
    let fechaF = moment(periodoD.fecha_fin);
    let fecha = moment(data.fecha_registro);

    if (fecha >= fechaI && fecha <= fechaF) {
        if (data.total_linea === 0.00 || data.total_linea === undefined){
            Swal.fire({
                title: 'Nota de débito',
                text: 'Total no puede ser 0.00',
                type: 'error',
            })
        }else{
            if (data.descripcion_linea === '' || data.descripcion_linea === undefined) {
                Swal.fire({
                    title: 'Nota de débito',
                    text: 'Debe de ingresar descripción',
                    type: 'error',
                })
            } else {
                if (data.tipo_gasto === '' || data.tipo_gasto === undefined || data.tipo_gasto === null) {
                    Swal.fire({
                        title: 'Nota de débito',
                        text: 'Debe de seleccionar tipo de gasto',
                        type: 'error',
                    })
                } else {
                    if (data.cuenta === '' || data.cuenta === undefined || data.cuenta === null) {
                        Swal.fire({
                            title: 'Nota de débito',
                            text: 'Debe de seleccionar cuenta contable',
                            type: 'error',
                        })
                    } else {
                        if (data.centro_costo === '' || data.centro_costo === undefined || data.centro_costo === null) {
                            Swal.fire({
                                title: 'Nota de débito',
                                text: 'Debe de seleccionar centro de costo',
                                type: 'error',
                            })
                        } else {
                            const formData = {
                                encabezado: id_emp[8],
                                descripcion: data.descripcion_linea,
                                total:data.total_linea,
                                gasto_id: data.tipo_gasto.value,
                                cuenta: data.cuenta.value,
                                cc: data.centro_costo.value,
                                empresa: id_emp[5]
                            }
                            dispatch(setLoader(true));
                            api.post('/distribuidor/nota_debito_detalle/', formData).then((response) => {
                                NotificationManager.success(
                                    'Linea ingresada correctamente',
                                    'Exito',
                                    3000
                                );
                                dispatch(initializeForm(
                                    'FormNotaDebitoVM', {
                                        ...data,
                                        tipo_gasto: null,
                                        cuenta: null,
                                        centro_costo: null
                                }));
                                dispatch(leerDetalleND(response.id));
                            }).catch((error) => {
                                NotificationManager.error(
                                    error.msj,
                                    'Error',
                                    2000
                                );
                            }).finally(() => {
                                dispatch(setLoader(false));
                            });
                        }
                    }
                }
            }
        }
    }else {
        Swal.fire({
            title: 'Nota de débito',
            text: 'Fecha fuera del periodo',
            type: 'error',
        })
    }
}

export const modificarNotaDebito = (periodoD) => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormNotaDebitoVM.values;
    let id = data.id;
    let fechaI = moment(periodoD.fecha_inicio);
    let fechaF = moment(periodoD.fecha_fin);
    let fecha = moment(data.fecha_registro);
    if (fecha>=fechaI && fecha<=fechaF){
        let distribuidor = data.distribuidor_mod;
        if (distribuidor === undefined){
            distribuidor = data.distribuidor;
        }else{
            distribuidor = data.distribuidor_mod.value;
        }
        const formData = {
            id: id,
            fecha_registro: data.fecha_registro,
            descripcion: data.descripcion,
            distribuidor: distribuidor,
            numero: data.numero,
        }
        dispatch(setLoader(true));
        api.put(`/distribuidor/nota_debito/${id}/`, formData).then(() => {
            NotificationManager.success(
                'Nota de débito modificada correctamente',
                'Exito',
                3000
            );
            let ruta = `/visitador_medico/${id_emp[5]}/nota_debito/${id_emp[7]}`
            dispatch(push(ruta));
        }).catch((error) => {
            NotificationManager.error(
                error.msj,
                'Error',
                2000
            );
        }).finally(() => {
            dispatch(setLoader(false));
        });
    }else {
        Swal.fire({
            title: 'Nota de débito',
            text: 'Fecha fuera del periodo',
            type: 'error',
        })    
    }
}

export const buscarCuenta = (id) => (dispatch) => {
    api.get(`/distribuidor/tipo_gasto_detalle/${id}`).then((response) => {
        const cuentas = [];
        response.forEach(item=>{
            cuentas.push({
                value: item.cuenta_contable,
                label: item.nombre_cuenta
            })
        })
        dispatch({type: CUENTA_CONTABLE, cuentaContable: cuentas})
    }).catch(() => {
        return [];
    })
}

export const distribuidorCC = (id) => (dispatch) => {
    api.get(`/distribuidor/distribuidor/${id}`).then((response) => {
        dispatch({type: NOMBRE_CC, nombre_centro_costo: response.nombre_centro_costo })
    }).catch(() => {
        return [];
    })
}

const eliminarND = id => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    dispatch(setLoader(true));
    api.eliminar(`/distribuidor/nota_debito/${id}`).then(() => {
        dispatch(listar(id_emp[7]));
        NotificationManager.success(
            'Nota débito borrada correctamente',
            'Exito',
            3000
        );
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en eliminar nota débito',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const actions = {
    leer,
    listar,
    leerPeriodoD,
    getModulo,
    parametrosEmpresa,
    listarDistribuidor,
    listarTiposGasto,
    agregarLinea,
    actualizar,
    registroNotaDebito,
    eliminarLineaNota,
    eliminarLinea,
    limpiar,
    agregarNuevaLinea,
    modificarNotaDebito,
    buscarCuenta,
    distribuidorCC,
    listarDistribuidorCC,
    eliminarND
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO_ND]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [NOTA_DEBITO]: (state, { lectura }) => {
        return {
            ...state,
            lectura,
        };
    },
    [DETALLE_ND]: (state, { detalleND }) => {
        return {
            ...state,
            detalleND,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
    [PERIODO_D]: (state, { periodoD }) => {
        return {
            ...state,
            periodoD,
        };
    },
    [PARAMETRO]: (state, { datos }) => {
        return {
            ...state,
            datos,
        };
    },
    [LOADERC]: (state, { loaderC }) => {
        return {
            ...state,
            loaderC,
        };
    },
    [DETALLE]: (state, { detalleDocN }) => {
        return {
            ...state,
            detalleDocN,
        };
    },
    [CUENTA_CONTABLE]: (state, { cuentaContable }) => {
        return {
            ...state,
            cuentaContable,
        };
    },
    [LISTA_GASTOS]: (state, { gastos}) => {
        return {
            ...state,
            gastos,
        };
    },
    [NOMBRE_CC]: (state, { nombre_centro_costo }) => {
        return {
            ...state,
            nombre_centro_costo,
        };
    },
};

export const initialState = {
    loader: false,
    lectura: [],
    modulo: [],
    periodoD: [],
    data: [],
    datos: [],
    loaderC: false,
    detalle: [],
    detalleND: [],
    data: [],
    lista_cuentas: [],
    page: 1,
    cuentaContable: [],
    gastos: [],
    nombre_centro_costo: ""
};

export default handleActions(reducers, initialState)